module.exports = __webpack_public_path__ + "static/media/Colette Wing Queen Headboard - 155 cm_Grey.cbf15075.png";